import script from "./LootboxesStore.vue?vue&type=script&lang=ts&setup=true"
export * from "./LootboxesStore.vue?vue&type=script&lang=ts&setup=true"

import "./LootboxesStore.vue?vue&type=style&index=0&id=5f8e7110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8e7110"]])

export default __exports__